export const ONE_SECOND = 1e3; // ms
export const FIVE_SECONDS = ONE_SECOND * 5;
export const THIRTY_SECONDS = ONE_SECOND * 30;
export const ONE_MINUTE = 60 * ONE_SECOND;
export const ONE_HOUR = 60 * ONE_MINUTE;
export const ONE_DAY = 24 * ONE_HOUR;
export const ONE_WEEK = 7 * ONE_DAY;
export const ONE_MONTH = 4 * ONE_WEEK;
export const TWO_MONTHS = 2 * ONE_MONTH;

export const MINUTE = 'MINUTE';
export const HOUR = 'HOUR';
export const WEEK = 'WEEK';
export const MONTH = 'MONTH';

export type RefreshIntervalType = 'MINUTE' | 'HOUR' | 'WEEK' | 'MONTH';
